import { Button } from "../../components/Button";
import { formatIrkutskDateTime } from "../../lib/time";

export function AdminMarketSection({
  onSectionSubmit,
  sectionDraft,
  setSectionDraft,
  loading,
  marketSections,
  toggleMarketSection,
  removeMarketSection,
  onMarketSubmit,
  editingMarketItemId,
  marketDraft,
  setMarketDraft,
  onMarketImageChange,
  uploadingImage,
  onSetMarketPreview,
  onRemoveMarketImage,
  resetMarketDraft,
  marketItems,
  marketReservations,
  toggleMarketItem,
  startEditMarketItem,
  removeMarketItem,
}) {
  return (
    <>
      <form className="adminForm" onSubmit={onSectionSubmit}>
        <h3>Добавить подраздел</h3>
        <label className="field">
          Название подраздела
          <input
            type="text"
            placeholder="Например, Футболки"
            value={sectionDraft.title}
            onChange={(e) => setSectionDraft((prev) => ({ ...prev, title: e.target.value }))}
          />
        </label>
        <label className="field">
          Порядок
          <input
            type="number"
            min="0"
            value={sectionDraft.sort_order}
            onChange={(e) =>
              setSectionDraft((prev) => ({ ...prev, sort_order: e.target.value }))
            }
          />
        </label>
        <label className="field field--inline">
          <input
            type="checkbox"
            checked={sectionDraft.is_active}
            onChange={(e) =>
              setSectionDraft((prev) => ({ ...prev, is_active: e.target.checked }))
            }
          />
          Активный подраздел
        </label>
        <Button type="submit" variant="accent">
          Добавить подраздел
        </Button>
      </form>

      <section className="adminGroup">
        <h3>Подразделы</h3>
        {loading ? <p className="muted">Загрузка...</p> : null}
        {!loading && marketSections.length === 0 ? (
          <p className="muted">Пока подразделов нет.</p>
        ) : null}
        {!loading
          ? marketSections.map((sectionItem) => (
              <article key={sectionItem.id} className="adminItem">
                <div>
                  <h4>{sectionItem.title}</h4>
                  <p>Порядок: {sectionItem.sort_order}</p>
                  <p className="muted">
                    Статус: {sectionItem.is_active ? "активен" : "скрыт"}
                  </p>
                </div>
                <div className="adminItemActions">
                  <Button type="button" onClick={() => toggleMarketSection(sectionItem)}>
                    {sectionItem.is_active ? "Скрыть" : "Показать"}
                  </Button>
                  <Button type="button" onClick={() => removeMarketSection(sectionItem)}>
                    Удалить
                  </Button>
                </div>
              </article>
            ))
          : null}
      </section>

      <form className="adminForm" onSubmit={onMarketSubmit}>
        <h3>{editingMarketItemId ? "Редактировать товар" : "Добавить товар"}</h3>
        <label className="field">
          Подраздел
          <select
            value={marketDraft.section_id}
            onChange={(e) => setMarketDraft((prev) => ({ ...prev, section_id: e.target.value }))}
          >
            {marketSections.map((sectionItem) => (
              <option key={sectionItem.id} value={sectionItem.id}>
                {sectionItem.title}
              </option>
            ))}
          </select>
        </label>
        <label className="field">
          Название
          <input
            type="text"
            placeholder="Например, Худи Stihiya"
            value={marketDraft.title}
            onChange={(e) => setMarketDraft((prev) => ({ ...prev, title: e.target.value }))}
          />
        </label>
        <label className="field">
          Описание
          <textarea
            rows="3"
            placeholder="Описание товара"
            value={marketDraft.description}
            onChange={(e) =>
              setMarketDraft((prev) => ({ ...prev, description: e.target.value }))
            }
          />
        </label>
        <label className="field">
          Цена (руб)
          <input
            type="number"
            step="0.01"
            min="0"
            placeholder="0"
            value={marketDraft.price}
            onChange={(e) => setMarketDraft((prev) => ({ ...prev, price: e.target.value }))}
          />
        </label>
        <label className="field">
          Цена (баллы)
          <input
            type="number"
            min="0"
            placeholder="0"
            value={marketDraft.price_bonus}
            onChange={(e) =>
              setMarketDraft((prev) => ({ ...prev, price_bonus: e.target.value }))
            }
          />
        </label>
        <label className="field">
          Остаток (шт)
          <input
            type="number"
            min="0"
            placeholder="0"
            value={marketDraft.stock_quantity}
            onChange={(e) =>
              setMarketDraft((prev) => ({ ...prev, stock_quantity: e.target.value }))
            }
          />
        </label>
        <label className="field">
          Изображения
          <input type="file" accept="image/*" multiple onChange={onMarketImageChange} />
        </label>
        {uploadingImage ? <p className="muted">Загрузка изображения...</p> : null}
        {marketDraft.image_urls.length > 0 ? (
          <div className="adminGalleryList">
            {marketDraft.image_urls.map((url) => (
              <div
                key={url}
                className={`adminGalleryItem ${marketDraft.image_url === url ? "isPreview" : ""}`}
              >
                <div className="adminImagePreview adminImagePreview--small">
                  <img src={url} alt="Фото товара" />
                </div>
                <div className="adminGalleryItem__actions">
                  <Button
                    type="button"
                    onClick={() => onSetMarketPreview(url)}
                    disabled={marketDraft.image_url === url}
                  >
                    {marketDraft.image_url === url ? "Превью" : "Сделать превью"}
                  </Button>
                  <Button type="button" onClick={() => onRemoveMarketImage(url)}>
                    Удалить фото
                  </Button>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        <label className="field field--inline">
          <input
            type="checkbox"
            checked={marketDraft.is_active}
            onChange={(e) =>
              setMarketDraft((prev) => ({ ...prev, is_active: e.target.checked }))
            }
          />
          Показать в маркете
        </label>
        <Button type="submit" variant="accent" disabled={uploadingImage}>
          {editingMarketItemId ? "Сохранить товар" : "Добавить товар"}
        </Button>
        {editingMarketItemId ? (
          <Button type="button" onClick={resetMarketDraft}>
            Отменить редактирование
          </Button>
        ) : null}
      </form>

      <section className="adminGroup">
        <h3>Товары</h3>
        {loading ? <p className="muted">Загрузка...</p> : null}
        {!loading && marketItems.length === 0 ? <p className="muted">Пока нет товаров.</p> : null}
        {!loading
          ? marketItems.map((item) => (
              <article key={item.id} className="adminItem">
                <div>
                  <h4>{item.title}</h4>
                  <p className="muted">Раздел: {item.section_title || "—"}</p>
                  <p>{item.description}</p>
                  <p>
                    Цена: {Number(item.price || 0).toFixed(2)} руб. /{" "}
                    {Number(item.price_bonus || 0)} баллов
                  </p>
                  <p>Остаток: {Number(item.stock_quantity || 0)} шт.</p>
                  {item.image_url ? (
                    <div className="adminImagePreview adminImagePreview--small">
                      <img src={item.image_url} alt={item.title} />
                    </div>
                  ) : null}
                  <p className="muted">Статус: {item.is_active ? "активен" : "черновик"}</p>
                </div>
                <div className="adminItemActions">
                  <Button type="button" onClick={() => toggleMarketItem(item)}>
                    {item.is_active ? "Скрыть" : "Показать"}
                  </Button>
                  <Button type="button" onClick={() => startEditMarketItem(item)}>
                    Править
                  </Button>
                  <Button type="button" onClick={() => removeMarketItem(item)}>
                    Удалить
                  </Button>
                </div>
              </article>
            ))
          : null}
      </section>

      <section className="adminGroup">
        <h3>Активные брони (24ч)</h3>
        {loading ? <p className="muted">Загрузка...</p> : null}
        {!loading && marketReservations.length === 0 ? (
          <p className="muted">Сейчас активных броней нет.</p>
        ) : null}
        {!loading
          ? marketReservations.map((reservation) => (
              <article key={reservation.reservation_id} className="adminItem">
                <div>
                  <h4>{reservation.title}</h4>
                  <p>ID товара: {reservation.merch_item_id}</p>
                  <p>Клиент Telegram ID: {reservation.user_telegram_id}</p>
                  <p>Оплата: {reservation.payment_type === "bonus" ? "баллы" : "рубли"}</p>
                  <p className="muted">
                    Действует до: {formatIrkutskDateTime(reservation.expires_at)}
                  </p>
                </div>
              </article>
            ))
          : null}
      </section>
    </>
  );
}

